import { useHistory } from 'react-router-dom';


const SupportPortal = () => {
  const history = useHistory();
  const url = 'https://liveramp.my.salesforce-sites.com/WebCaseCreatePage/cleanroomcasecreationpage';
  window.open(url, '_blank');
  history.goBack();
  return null;
};

export default SupportPortal;
